import {
    MEMBERS_ONLINE_START,
    MEMBERS_ONLINE_SUCCESS,
    MEMBERS_ONLINE_ERROR,
} from 'state/actions/clan_members_online'

const initialState = {
    membersOnline: null,
    membersTotal: null,
    loading: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case MEMBERS_ONLINE_START: {
        return {
            ...state,
            loading: true,
        }
    }
    case MEMBERS_ONLINE_SUCCESS: {
        return {
            ...state,
            loading: false,
            membersOnline: action.payload.members_online,
            membersTotal: action.payload.members_total,
        }
    }
    case MEMBERS_ONLINE_ERROR: {
        return {
            ...state,
            loading: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/clan_members_online.js